
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function BidderDashboard() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('opportunities');

  const stats = [
    { label: '可投标项目', value: '45', icon: 'ri-file-list-line', color: 'bg-green-500' },
    { label: '已投标', value: '12', icon: 'ri-send-plane-line', color: 'bg-blue-500' },
    { label: '中标项目', value: '8', icon: 'ri-trophy-line', color: 'bg-yellow-500' },
    { label: '中标率', value: '66.7%', icon: 'ri-percent-line', color: 'bg-purple-500' }
  ];

  const opportunities = [
    {
      id: 1,
      name: '市政道路改造工程项目',
      code: 'ZB2024001',
      budget: '¥5,000万',
      publisher: '市政建设局',
      deadline: '2024-02-15 17:00',
      daysLeft: 5,
      requirements: ['施工资质一级', '注册资金≥5000万', '类似项目经验≥3个']
    },
    {
      id: 2,
      name: '智慧园区信息化建设',
      code: 'ZB2024005',
      budget: '¥2,800万',
      publisher: '高新技术开发区',
      deadline: '2024-02-18 17:00',
      daysLeft: 8,
      requirements: ['软件开发资质', '信息安全等级保护', '成功案例≥5个']
    },
    {
      id: 3,
      name: '医院医疗设备采购',
      code: 'ZB2024006',
      budget: '¥1,500万',
      publisher: '市人民医院',
      deadline: '2024-02-20 17:00',
      daysLeft: 10,
      requirements: ['医疗器械经营许可', '售后服务网点', '产品认证证书']
    }
  ];

  const myBids = [
    {
      id: 1,
      name: '办公楼装修工程',
      code: 'ZB2024002',
      bidAmount: '¥750万',
      status: '评审中',
      submitTime: '2024-01-10 15:30',
      ranking: 2
    },
    {
      id: 2,
      name: '园林绿化工程',
      code: 'ZB2024004',
      bidAmount: '¥580万',
      status: '已中标',
      submitTime: '2024-01-08 14:20',
      ranking: 1
    },
    {
      id: 3,
      name: '信息化系统建设项目',
      code: 'ZB2024003',
      bidAmount: '¥1,150万',
      status: '未中标',
      submitTime: '2024-01-05 16:45',
      ranking: 4
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-200">
        <div className="px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <button onClick={() => navigate('/')} className="text-gray-600 hover:text-gray-900 cursor-pointer whitespace-nowrap">
                <i className="ri-arrow-left-line text-xl"></i>
              </button>
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-green-500 rounded-lg flex items-center justify-center">
                  <i className="ri-briefcase-line text-xl text-white"></i>
                </div>
                <div>
                  <h1 className="text-xl font-bold text-gray-900">投标方工作台</h1>
                  <p className="text-sm text-gray-500">工程建设股份公司</p>
                </div>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <button className="px-4 py-2 text-gray-600 hover:text-gray-900 whitespace-nowrap cursor-pointer">
                <i className="ri-notification-line text-xl"></i>
              </button>
              <button className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 whitespace-nowrap cursor-pointer">
                <i className="ri-search-line mr-2"></i>
                搜索项目
              </button>
            </div>
          </div>
        </div>
      </header>

      <div className="p-6">
        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
          {stats.map((stat, index) => (
            <div key={index} className="bg-white rounded-xl shadow-sm p-6 hover:shadow-md transition-shadow">
              <div className="flex items-center justify-between mb-4">
                <div className={`w-12 h-12 ${stat.color} rounded-lg flex items-center justify-center`}>
                  <i className={`${stat.icon} text-2xl text-white`}></i>
                </div>
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-1">{stat.value}</div>
              <div className="text-sm text-gray-500">{stat.label}</div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Main Content */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-xl shadow-sm">
              <div className="border-b border-gray-200 px-6">
                <div className="flex space-x-8">
                  {[
                    { id: 'opportunities', label: '招标机会', icon: 'ri-search-eye-line' },
                    { id: 'mybids', label: '我的投标', icon: 'ri-file-list-3-line' },
                    { id: 'won', label: '中标项目', icon: 'ri-trophy-line' }
                  ].map((tab) => (
                    <button
                      key={tab.id}
                      onClick={() => setActiveTab(tab.id)}
                      className={`py-4 px-2 border-b-2 font-medium text-sm whitespace-nowrap cursor-pointer transition-colors ${
                        activeTab === tab.id
                          ? 'border-green-600 text-green-600'
                          : 'border-transparent text-gray-500 hover:text-gray-700'
                      }`}
                    >
                      <i className={`${tab.icon} mr-2`}></i>
                      {tab.label}
                    </button>
                  ))}
                </div>
              </div>

              <div className="p-6">
                {activeTab === 'opportunities' && (
                  <div className="space-y-4">
                    {opportunities.map((opp) => (
                      <div key={opp.id} className="border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow">
                        <div className="flex items-start justify-between mb-4">
                          <div className="flex-1">
                            <div className="flex items-center space-x-3 mb-2">
                              <h3 className="text-lg font-bold text-gray-900">{opp.name}</h3>
                              <span className="px-3 py-1 bg-green-100 text-green-700 text-xs font-semibold rounded-full whitespace-nowrap">
                                进行中
                              </span>
                            </div>
                            <div className="flex items-center space-x-6 text-sm text-gray-600 mb-3">
                              <span><i className="ri-price-tag-3-line mr-1"></i>{opp.code}</span>
                              <span><i className="ri-building-line mr-1"></i>{opp.publisher}</span>
                              <span><i className="ri-money-cny-circle-line mr-1"></i>{opp.budget}</span>
                            </div>
                            <div className="flex flex-wrap gap-2 mb-3">
                              {opp.requirements.map((req, idx) => (
                                <span key={idx} className="px-3 py-1 bg-blue-50 text-blue-700 text-xs rounded-full whitespace-nowrap">
                                  {req}
                                </span>
                              ))}
                            </div>
                          </div>
                        </div>
                        <div className="flex items-center justify-between pt-4 border-t border-gray-200">
                          <div className="flex items-center space-x-4">
                            <div className="text-sm">
                              <i className="ri-calendar-line mr-1 text-gray-400"></i>
                              <span className="text-gray-600">截止时间: </span>
                              <span className="font-semibold text-gray-900">{opp.deadline}</span>
                            </div>
                            <div className={`px-3 py-1 rounded-full text-xs font-semibold whitespace-nowrap ${
                              opp.daysLeft <= 3 ? 'bg-red-100 text-red-700' : 'bg-orange-100 text-orange-700'
                            }`}>
                              剩余{opp.daysLeft}天
                            </div>
                          </div>
                          <div className="flex items-center space-x-2">
                            <button className="px-4 py-2 text-green-600 border border-green-600 rounded-lg hover:bg-green-50 whitespace-nowrap cursor-pointer">
                              查看详情
                            </button>
                            <button className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 whitespace-nowrap cursor-pointer">
                              立即投标
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                {activeTab === 'mybids' && (
                  <div className="space-y-4">
                    {myBids.map((bid) => (
                      <div key={bid.id} className="border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow">
                        <div className="flex items-start justify-between mb-4">
                          <div className="flex-1">
                            <div className="flex items-center space-x-3 mb-2">
                              <h3 className="text-lg font-bold text-gray-900">{bid.name}</h3>
                              <span className={`px-3 py-1 text-xs font-semibold rounded-full whitespace-nowrap ${
                                bid.status === '已中标' ? 'bg-green-100 text-green-700' :
                                bid.status === '评审中' ? 'bg-blue-100 text-blue-700' :
                                'bg-gray-100 text-gray-700'
                              }`}>
                                {bid.status}
                              </span>
                              {bid.ranking === 1 && (
                                <span className="px-3 py-1 bg-yellow-100 text-yellow-700 text-xs font-semibold rounded-full whitespace-nowrap">
                                  <i className="ri-trophy-line mr-1"></i>第1名
                                </span>
                              )}
                            </div>
                            <div className="flex items-center space-x-6 text-sm text-gray-600">
                              <span><i className="ri-price-tag-3-line mr-1"></i>{bid.code}</span>
                              <span><i className="ri-money-cny-circle-line mr-1"></i>投标金额: {bid.bidAmount}</span>
                              <span><i className="ri-time-line mr-1"></i>提交时间: {bid.submitTime}</span>
                            </div>
                          </div>
                        </div>
                        <div className="flex items-center justify-end space-x-2">
                          <button className="px-4 py-2 text-green-600 border border-green-600 rounded-lg hover:bg-green-50 whitespace-nowrap cursor-pointer">
                            查看详情
                          </button>
                          {bid.status === '已中标' && (
                            <button className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 whitespace-nowrap cursor-pointer">
                              签订合同
                            </button>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                {activeTab === 'won' && (
                  <div>
                    <div className="text-center py-12">
                      <div className="w-20 h-20 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
                        <i className="ri-trophy-line text-4xl text-yellow-600"></i>
                      </div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">中标项目</h3>
                      <p className="text-gray-600 mb-4">查看所有中标项目和合同</p>
                      <button className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 whitespace-nowrap cursor-pointer">
                        查看中标项目
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <div className="space-y-6">
            {/* Company Info */}
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h3 className="text-lg font-bold text-gray-900 mb-4">企业信息</h3>
              <div className="space-y-3">
                <div className="flex items-center justify-between text-sm">
                  <span className="text-gray-600">企业资质</span>
                  <span className="font-semibold text-green-600">已认证</span>
                </div>
                <div className="flex items-center justify-between text-sm">
                  <span className="text-gray-600">信用等级</span>
                  <span className="font-semibold text-gray-900">AAA</span>
                </div>
                <div className="flex items-center justify-between text-sm">
                  <span className="text-gray-600">注册资金</span>
                  <span className="font-semibold text-gray-900">¥5000万</span>
                </div>
                <div className="flex items-center justify-between text-sm">
                  <span className="text-gray-600">成立时间</span>
                  <span className="font-semibold text-gray-900">2010年</span>
                </div>
              </div>
              <button className="w-full mt-4 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 whitespace-nowrap cursor-pointer">
                完善企业信息
              </button>
            </div>

            {/* Tips */}
            <div className="bg-gradient-to-br from-green-500 to-green-600 rounded-xl shadow-sm p-6 text-white">
              <h3 className="text-lg font-bold mb-4">投标小贴士</h3>
              <ul className="space-y-3 text-sm">
                <li className="flex items-start space-x-2">
                  <i className="ri-checkbox-circle-line mt-0.5 flex-shrink-0"></i>
                  <span>仔细阅读招标文件要求</span>
                </li>
                <li className="flex items-start space-x-2">
                  <i className="ri-checkbox-circle-line mt-0.5 flex-shrink-0"></i>
                  <span>提前准备相关资质证明</span>
                </li>
                <li className="flex items-start space-x-2">
                  <i className="ri-checkbox-circle-line mt-0.5 flex-shrink-0"></i>
                  <span>合理报价提高中标率</span>
                </li>
                <li className="flex items-start space-x-2">
                  <i className="ri-checkbox-circle-line mt-0.5 flex-shrink-0"></i>
                  <span>注意投标截止时间</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
